import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import UpdateQuantityForManualInventory from "../../../../components/UpdateQuantityForManualInventory";
import EnterQuantityForManualInventory from "../../../../components/EnterQuantityForManualInventory";

const animatedComponents = makeAnimated();
const AddInventory = (props) => {
  
  const store_id = localStorage.getItem("store_id")
  const role = localStorage.getItem("role")
  useEffect(() => {
    loadAllProducts();
    if (props.selectedProduct) {
      setSelectedProduct(props.selectedProduct);
      setSelectUnitModal(!selectUnitModal)
    }
    if(role==="Operations Manager") loadStores();
  }, []);

  const refContainer = useRef(null);
  const refSelectProduct = useRef(null);
  const [isLoading , setIsLoading] = useState(false)
  
  const handleValidSubmit = async (e, v) => {
    try {
      // if(!selectedProduct.quantity){
      //   showNotification("Please enter a valid quantity","Warning")
      //   return
      // }
      // else if (selectedProduct.quantity && selectedProduct.quantity.every(({ value }) => (value == "0" || value == 0 || value === ""))) {
      //   showNotification("Please enter a valid quantity for at least one unit","Warning");
      //   return;
      // }
      setIsLoading(true)
      let data_to_send = {};
      data_to_send.store_id = role==="Operations Manager" ? selectedStore[0]._id :store_id;
      data_to_send.product_id = selectedProduct._id;
      data_to_send.unit_levels = selectedProduct.unit_levels;
      data_to_send.quantity = selectedProduct.quantity.map(({ unit, value }) => ({ unit, value:parseInt(value) }));
      data_to_send.cost_price = v.cost_price;
      data_to_send.selling_price = v.selling_price;
      data_to_send.remarks = v.remarks;
      if(role==="Storekeeper"){
        data_to_send.inventory_type = "Kitchen"
      }
// return
      let endpoint = props.reset ? 'storesitemstransfer/product_manual_entry' : 'storeproductinventories/insert';
      let url = process.env.REACT_APP_BASEURL + endpoint;
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        showNotification(response.message, "Success");
        refSelectProduct.current.select.clearValue();
        refContainer.current.reset();
        setSelectUnitModal(false)
        setEditUnitModal(false)
        if (props.isRefreshData) {
          props.refreshData();
          props.handleClosePopup();
        }
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const [allProducts, setAllProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const loadAllProducts = async () => {
    let url = process.env.REACT_APP_BASEURL + "products/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllProducts(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [selectedStore, setSelectedStore] = useState([]);
  const loadStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const result = response.data.filter(store=>store.type === "CENTRAL KITCHEN STORE")
      setSelectedStore(result);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [selectUnitModal, setSelectUnitModal] = useState(false)
  function handleSelectProduct (selected) {
    setSelectedProduct(selected)
    setSelectUnitModal(!selectUnitModal)
  }

  const [editUnitModal, setEditUnitModal] = useState(false);


function handleToggle() {
    setSelectUnitModal(false);
    setEditUnitModal(false)
}
function handleAddQuantity(quantity) {
  const updatedProd = { ...selectedProduct };
    let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
    updatedProd.quantity=convertedQuantity    
  setSelectedProduct(updatedProd);
  setSelectUnitModal(false);
}

const handleUpdateQuantity = (quantity) => {
  const updatedProd = { ...selectedProduct };
  let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
  updatedProd.quantity=convertedQuantity
    setSelectedProduct(updatedProd);
    setEditUnitModal(false);
};
  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <AvForm
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v);
                }}
                ref={refContainer}
              >
                <CardTitle>{props.t("Update Inventory")}</CardTitle>
                <CardSubtitle className="mb-3">
                  {props.t(
                    "Enter the following details to add products to inventory"
                  )}
                </CardSubtitle>
                <Row>
                  <Col lg={6}>
                    <Label>{props.t("Product")}</Label>
                    <Select
                      ref={refSelectProduct}
                      value={selectedProduct}
                      onChange={(selected) => {
                        handleSelectProduct(selected)
                      }}
                      options={allProducts}
                      classNamePrefix="select2-selection"
                      components={animatedComponents}
                      required
                    />
                  </Col>
                  {selectedProduct?.quantity?.length>0 && (
                    <Col lg={6}>
                    <Label>{props.t("Quantity")}</Label> <br />
                       {formatUnitsForReport(selectedProduct?.quantity) }
                       <Button
                  className="btn btn-success waves-effect waves-light btn-sm ms-5"
                  onClick={() => {
                    setEditUnitModal(!editUnitModal);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
                  </Col>
                  )}
                  <Col lg={6}>
                    <Label>
                      {props.t("Cost Price")}
                      {selectedProduct && " (per " + selectedProduct.unit_for_cost_price + ")"}
                    </Label>
                    <AvField
                      name="cost_price"
                      placeholder={props.t("Enter Cost Price")}
                      type="text"
                      value={selectedProduct && selectedProduct.cost_price}
                      //disabled={true}
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                        // min: {
                        //   value: 0.1,
                        //   errorMessage: props.t("Price must be greater than or equal to 0.1"),
                        // },
                        required:{value:true,errorMessage: props.t("cost price is required."),
                        }
                      }}
                    />
                  </Col>
                  <Col lg={6}>
                    <Label>
                      {props.t("Selling Price")}
                      {selectedProduct && " (per " + selectedProduct.unit_for_selling_price + ")"}
                    </Label>
                    <AvField
                      name="selling_price"
                      placeholder={props.t("Enter Selling Price")}
                      type="text"
                      value={selectedProduct && selectedProduct.selling_price}
                      //disabled={true}
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                      }}
                    />
                  </Col>
                  <Col lg={6}>
                    <AvField
                      name="remarks"
                      label={props.t("Remarks")}
                      placeholder={props.t("Enter Remarks")}
                      type="textarea"
                    />
                  </Col>
                  <Col lg={12}>
                    <hr />
                    <FormGroup className="mb-0 text-center">
                    <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"100px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Submit")}
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>

     {/* Add unit modal  */}
           
           <EnterQuantityForManualInventory
                  isOpen={selectUnitModal}
                  toggle={handleToggle}
                  onSubmit={handleAddQuantity}
                  item={selectedProduct}
                />

       {/* Edit Units Modal  */}
       <UpdateQuantityForManualInventory
                   isOpen={editUnitModal}
                   toggle={handleToggle}
                   onSubmit={handleUpdateQuantity}
                   item={selectedProduct}
                  />
        </Col>
      </Row>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AddInventory))
);
